import React, { useEffect, useState } from "react";

import { Gallery } from "../../Components/Gallery/Gallery";
import { CatagoryButtonGroup } from "../../Components/ButtonGroup/CatagoryButtonGroup";
import { Header } from "../../Components/Header/Header";
import { AllProducts } from "../../Components/AllProducts/AllProducts";
import { Grid, Typography } from "@mui/material";
import { getAllProduct } from "../../Services/ProductService";
import { useDispatch, useSelector } from "react-redux";
import { prodcutType } from "../../Types/ProductTypes";
import { getProduct } from "../../Redux/Actions/ProductActions/ProductActions";

export const HomePage = () => {
  const dispatch = useDispatch();
  const productData: Array<prodcutType> = useSelector(
    (data: any) => data.rootReducers.handleProduct
  );
  const [Products, setProducts] = useState<[] | Array<prodcutType>>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!productData.length) {
      getProducts();
    } else {
      setProducts(productData);
    }
    return () => {
      setProducts([]);
    };
  }, []);

  const getProducts = () => {
    setLoading(true);
    getAllProduct()
      .then(
        (res: any) => {
          const data = dispatch(getProduct(res.data));
          setProducts(data.payload);
          setLoading(false);
        },
        (err: any) => {
          console.log(err);

          setLoading(false);
        }
      )
      .catch((error) => {
        console.log(error);
        setLoading(false);
        throw error;
      });
  };

  return (
    <>
      <Grid container direction="column" gap={2} justifyContent={"center"}>
        <Grid xs={12} item>
          <Header />
          <Gallery loading={loading} productData={productData} />
        </Grid>
        <Grid container justifyContent="center" item xs={12}>
          <Typography variant="h4">Products</Typography>
        </Grid>
        <Grid item className="category_btn" xs={12}>
          <CatagoryButtonGroup />
        </Grid>
        <Grid item xs={12}>
          <AllProducts loading={loading} />
        </Grid>
      </Grid>
    </>
  );
};
